module.exports = __webpack_public_path__ + "img/@logo_amore@3x.ca58faf4.png";